
<template>
  <section>
    <one-line-form :button="false" class="question">
      <input-field type="text" class="disabled invisible" />
      <h5>{{ screenParams.text() }}</h5>
      <p class="description" v-if="screenParams.description">{{ screenParams.description()}} </p>
    </one-line-form>
    <option-selector class="options-selector-wrapper" ref="optionSelector" v-if="!screenParams.secondLayout" @selected="onSelected" :options="screenParams.answers($store)" :hasOther="screenParams.hasOther" :otherCopy="(screenParams.otherCopy && screenParams.otherCopy()) || ''" @other="goToOtherScreen" @submit="selectAnswer"></option-selector>
    <transition name="bottom" appear>
      <action-bar v-if="screenParams.secondLayout">
        <ul class="columns">
          <li v-for="item in screenParams.answers($store)" :key="item.id" @click="selectAnswer(item)" :class="{saving : isSaving && item.id === answer, primary: !!item.primary}"> {{item.label}} </li>
        </ul>
      </action-bar>
    </transition>
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/mixins';

  ul {
    @include button-list;
  }

  input {
    &::-webkit-input-placeholder {
      font-weight: 400;
    }
    &[disabled] {
      color: black;
    }

    border-bottom-color: transparent;
  }

  .input-wrapper.invisible{
    position: absolute;
  }

  /deep/ h5 {
    white-space: pre-line;
  }

  @include desktop-big {
    section {
      .options-selector-wrapper {
        left: -115px;
        top: -230px;
      }
    }
  }
</style>

<script>
  import Vue from 'vue'

  import { setSelection } from '../utils/selection'

  export default Vue.component('gender-name-screen', {
    props: ['screenParams'],
    data () {
      return {
        answer: this.screenParams.currentAnswer(this.$store),
        visibleQuestion: true,
        isSaving: false
      }
    },
    computed: {
      hint () {
        return this.screenParams.hint(this.$store) ? this.screenParams.hint(this.$store) : ''
      }
    },
    methods: {
      selectAnswer (answer) {
        this.isSaving = true
        this.answer = answer.id

        let answerData = {}
        answerData[this.screenParams.propertyName] = this.answer

        this.$store.dispatch(this.screenParams.dispatchKey, answerData)

        this.$emit('tooltip', 'hide')

        this.$store.dispatch('next', this.screenParams.nextScreenRoute)
      },
      onSelected () {
        if (this.screenParams && this.screenParams.showKeyboardOnNextScreen) {
          const input = this.$el.querySelector('input')
          if (input) {
            input.setAttribute('readonly', 'true')
            setSelection(input, { start: 0, end: 0 })
          }
        }
      },
      goToOtherScreen () {
        if (this.screenParams.hasOther) {
          this.$store.dispatch('updateApp', {
            [this.screenParams.hasOtherPropertyFlag]: true
          })
          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        }
      }
    },
    mounted () {
      const isList = (this.screenParams.answers && this.screenParams.answers(this.$store).length) > 2
      this.$emit('tooltip', isList ? ['vertical', 'enter'] : ['horizontal', 'enter'])
    }
  })
</script>


// WEBPACK FOOTER //
// src/screens/Question.vue